import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Modal, Button, Row, Col, Icon } from "react-materialize";
import SetAddressForm from './SetAddressForm';
import VehicleSelectionModal from './vehicleSelectionModal';
import {
  loadVehicleData,
  loadAvailableScheduleTypes,
  loadClientLocationDetailsAndPriceList,
} from '../../brain2';
import {
  Z3P_CONFIG,
  tracRudderStackkEvent,
  currentPageInfo,
  // KEY_LOCATION_OPTIONS,
} from '../../helper';
import Select from './Select';
import { stateNameToAbbreviation } from './UsStates';
import ShopLocationDropdown from './ShopLocationDropdown';
import PopupModal from './PopupModal';
import PopUpShopNow from './PopUpShopNow';

const LOCAL_KEY_Location = 'KeyLocation';

const KEY_LOCATION_OPTIONS = {
  placeHolder: "Where will we find your keys? *",
  contact: "Call/text me when you arrive. I'll hand the keys to you.",
  insideVehicle: 'I’ll leave them inside the vehicle.',
  frontDoor: 'I’ll leave them near the front door, or under the doormat.',
  mailbox: 'I’ll leave them in the mailbox.',
  tire: 'I’ll leave them on the front driver’s side tire.',
  other: 'Other',
};

const AddressModal = (props) => {
  const {
    isOpen,
    homeAddress,
    keyLocation,
    onClose = () => {},
    z3pConfiguration,
    clientLocations,
    vehicle,
    cart,
    dispatch,
  } = props;
  const { service_locations: serviceLocations } = z3pConfiguration;
  const [address, setAddress] = useState(null);
  const [locationName, setLocationName] = useState('');
  const [clientLocationId, setClientLocationId] = useState('');
  const [isLoadingLocations, setIsLoadingLocations] = useState(false);
  const [homeAddressValid, setHomeAddressValid] = useState(true);
  const [keyLocationOption, setKeyLocationOption] = useState('');
  const [additionalNote, setAdditionalNote] = useState('');
  const [openVehicleModal, setOpenVehicleModal] = useState(false);
  const [openVehicleSelectionModal, setOpenVehicleSelectionModal] = useState(
    false,
  );
  const [vehicleData, setVehicleData] = useState([]);
  const [pageView, setPageView] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenSecond, setModalOpenSecond] = useState(false);
  const [validateContinueBtn, setvalidateContinueBtn] = useState(false);
  const hasShopService = serviceLocations.includes('shop');
  const hasWorkplaceService = serviceLocations.includes('workplace');
  const hasHomeService = serviceLocations.includes('home');
  const [showDescription, setshowDescription] = useState(false);

  useEffect(() => {
    loadVehicleData().then((data) => {
      if (
        data.siteSearchResultGroupList &&
        Array.isArray(data.siteSearchResultGroupList)
      ) {
        setVehicleData(data.siteSearchResultGroupList); // Store data in state
      }
    });
    if (hasShopService) {
      setPageView('shop');
    }
    if (!hasShopService) {
      setPageView(serviceLocations[0]);
    }
  }, vehicleData);
  /* const setKeyLocation = (option) => {
        
        setKeyLocationOption(option);
    }; */

  const handleSubmit = () => {
    const stateName =
      address &&
      (stateNameToAbbreviation(address.state) || address.state.toUpperCase());

    if (!locationName && !address) {
      window.alert('Please choose a location.');
      return;
    }
    // eslint-disable-next-line no-undef
    const enteringAddressManually = localStorage.getItem(
      'enteringAddressManually',
    );

    tracRudderStackkEvent('Address_Filled', {
      proname: z3pConfiguration.z3p_client_name,
      path: currentPageInfo.PATH,
      url: currentPageInfo.URL,
      title: currentPageInfo.TITLE
        ? currentPageInfo.TITLE
        : Z3P_CONFIG.customer_facing_name,
      referrer: document.referrer,
      addressSelect: address.address_line_1,
      city: address.city,
      state: address.state,
      postal_code: address.postal_code,
      country: address.country,
      method: enteringAddressManually ? 'Manual' : 'Automated',
    });

    const vehicle_id = vehicle?.vehicle_id;
    if (address) {
      dispatch({
        type: 'SET_HOME_ADDRESS',
        address: address && {
          ...address,
          state: stateName,
          is_deleted: false,
          is_primary: false,
        },
        addressNameSelected:
          address && (address.display_name || address.address_line_1),
        keyLocationOption,
        additionalNote,
      });
      // Load the service offerings and prices
      loadClientLocationDetailsAndPriceList(dispatch, null, vehicle_id);
      navigateToNextPage();
    } else {
      loadAvailableScheduleTypes(clientLocationId).then(
        (availableScheduleTypes) => {
          dispatch({
            type: 'SET_AVAILABLE_SCHEDULE_TYPES',
            availableScheduleTypes,
          });
        },
      );

      loadClientLocationDetailsAndPriceList(
        dispatch,
        clientLocationId,
        vehicle_id,
      ).then(() => {
        navigateToNextPage();
      });
    }
  };

  const noteChange = (event) => {
    const newValue = event.target.value;
    if (newValue.length < 1020) {
      setAdditionalNote(newValue);
    } else {
      setAdditionalNote(newValue.substring(0, 1020));
    }
  };

  if (openVehicleModal) {
    setTimeout(function() {
      setOpenVehicleModal(false);
      setOpenVehicleSelectionModal(true);
    }, 2000);
  }

  // const handleVehicleModalClose = () => {
  //   setOpenVehicleModal(false);
  //   setOpenVehicleSelectionModal(true);
  // };

  const shouldAutoSelect =
    ['workplace', 'shop'].includes(pageView) && clientLocations.length === 1;

  useEffect(() => {
    if (shouldAutoSelect) {
      setLocationAndContinue(clientLocations[0]);
    }
  }, [pageView]);

  const setLocationAndContinue = (cl) => {
    const { short_name: locationShortName, client_location_id: clId } = cl;
    setLocationName(locationShortName);
    setClientLocationId(clId);

    loadAvailableScheduleTypes(clId).then((availableScheduleTypes) => {
      dispatch({
        type: 'SET_AVAILABLE_SCHEDULE_TYPES',
        availableScheduleTypes,
      });
    });

    // Auto-select client location and clear out home address
    const vehicle_id = vehicle?.vehicle_id;
    loadClientLocationDetailsAndPriceList(dispatch, clId, vehicle_id).then(
      () => {
        dispatch({
          type: 'SET_HOME_ADDRESS',
          address: {},
          addressIDSelected: null,
          addressNameSelected: null,
        });
      },
    );
    // eslint-disable-next-line no-use-before-define
    navigateToNextPage();
  };
  const navigateToNextPage = () => {
    onClose();
    setOpenVehicleModal(true);
    localStorage.removeItem('enteringAddressManually');
  };

  const handleClientChange = (event) => {
    const clientLocationId = event.target[
      event.target.selectedIndex
    ].getAttribute('data-client-location-id');

    setLocationName(event.target.value);
    setClientLocationId(clientLocationId);
  };

  const handleVehicleModulClose = (vehicleData) => {
    const { cart } = props;
    const isTireInstallation = cart.some(user => user.short_name === "Tire Installation");
    const isOtherService = cart.some(user => user.short_name === "Other");
    setOpenVehicleSelectionModal(false);
    if (isOtherService) {
      setModalOpen(true);
    } else if (isTireInstallation) {
      setModalOpenSecond(true);
    }
    else {
      return browserHistory.push('/pricing/schedule');
    }
  };



  const handleEditClick = () => {
    setOpenVehicleSelectionModal(true);
    setModalOpen(false);
  };

  const handleEditClickSecond = () => {
    setOpenVehicleSelectionModal(true);
    setModalOpenSecond(false);
  };

  const handleBackClickSecond = () => {
    setModalOpenSecond(false);
    const { cart } = props;
    const isOtherService = cart.some(user => user.short_name === "Other");
    console.log("--------isOtherService------", JSON.stringify(isOtherService))
    if (isOtherService) {
      setModalOpen(true);
    } 
  };
  const handleOnCancelClick = () => {
    setModalOpenSecond(false);
  };

  const handleNoThanksContinueClick = () => {
    setModalOpenSecond(false);
    return browserHistory.push('/pricing/schedule');
  };
  const handleContinueClick = () => {
    // setModalOpen(false);
    // setModalOpenSecond(true);
    // return browserHistory.push('/pricing/schedule');
    const { cart } = props;
    let checkService = false;
    for (let i = 0; i < cart.length; i++) {
      console.log(JSON.stringify(cart[i]));
      if (cart[i].short_name == 'Tire Installation') {
        checkService = true;
      }
    }
    if (checkService) {
      setModalOpen(false);
      setModalOpenSecond(true);
    } else {
      setModalOpen(false);
      setModalOpenSecond(true);
      return browserHistory.push('/pricing/schedule');
    }
  };

  function checkServiceOtherSelected() {
    const { cart } = props;
    let checkService = false;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < cart.length; i++) {
      if (cart[i].short_name == 'Other') {
        checkService = true;
      }
    }
    if (checkService) {
      return true;
    }
    return false;
  }

  const saveKeyLocation = (value) => {
    localStorage.setItem(LOCAL_KEY_Location, value);
    if (localStorage.getItem(LOCAL_KEY_Location) != null && homeAddressValid && value != "placeHolder") {
      setvalidateContinueBtn(true);
    } else {
      setvalidateContinueBtn(false);
    }
  };

  const customFooter = (
    <div className="modal-footer">
      <Button
        disabled={!validateContinueBtn}
        className="btn-large header"
        value="Continue"
        onClick={handleSubmit}
      >
        Continue
      </Button>
    </div>
  );

  const handleTireQuntityValue = (value) => {
    console.log('Received from child:', value);
  };

  let cartServices = [];
  if (cart.length !== 0) {
    cart.forEach((service) => {
      cartServices.push(service.service_offering_id);
    });
  }
  cartServices = cartServices.join(",");

  return (
    <>
      <Modal
        open={isOpen}
        actions={customFooter}
        className="modal-bottom address_modal"
        options={{ dismissible: false }}
      >
        {/* Header */}
        <div className="modal-header">
          <Row className="mb-0">
            <Col className="s12">
              <Button className="close-btn" onClick={onClose}>
                <Icon>close</Icon>
              </Button>
              <h3>What address would you like your service done?</h3>
              <p>
                Our mobile installer will complete your service at the location
                provided.
              </p>
            </Col>
          </Row>
        </div>

        {/* Modal Content */}
        <div className="modal-body">
          <Row className="mb-0">
            <Col className="s12">
              <h5>Address</h5>
            </Col>
          </Row>
          {pageView === 'home' && (
            <SetAddressForm
              strippedVersion
              onSetAddress={(addr) => {
                setAddress(addr);
              }}
              onSelectAddress={(addr) => {
                setAddress(addr);
              }}
              onChangeField={(addr) => {
                setAddress({ ...address, ...addr });
              }}
              onCheckAddressValidity={(validity) => {
                setHomeAddressValid(validity);
                const location = localStorage.getItem(LOCAL_KEY_Location);
                if (
                  location &&
                  location !== "placeHolder" &&
                  validity === true
                ) {
                  setvalidateContinueBtn(true);
                } else {
                  setvalidateContinueBtn(false);
                }
              }}
              homeAddress={homeAddress}
            /* setKeyLocation={setKeyLocation}
                      keyLocationOption={keyLocationOption}
                      additionalNote={additionalNote}
                      noteChange={noteChange} */
            />
          )}
          {pageView === 'shop' && (
            <div>
              <Row>
                <ShopLocationDropdown
                  handleClientChange={handleClientChange}
                  selectedClientLocation={locationName}
                  setLocationName={setLocationName}
                  setClientLocationId={setClientLocationId}
                  navigateToNextPage={navigateToNextPage}
                />
              </Row>

              {hasHomeService && (
                <Row>
                  <Col>
                    <Button onClick={() => setPageView('home')}>
                      Add a home address instead
                    </Button>
                  </Col>
                </Row>
              )}
            </div>
          )}
        </div>
        <div className="modal-body">
          <Row className="mb-0">
            <Col className="s12">
              <h5>Key Location</h5>
            </Col>
          </Row>
        </div>
        <div
          style={{
            marginLeft: '10px',
            marginRight: '10px',
            borderBottomWidth: '0px',
            borderColor: 'red',
          }}
          className="edit_address_form"
        >
          <Select
            s={12}
            m={12}
            onChange={(e) => saveKeyLocation(e.target.value)}
            id="keyLocationOption"
            name="keyLocationOption"
            value={localStorage.getItem(LOCAL_KEY_Location) != null ? localStorage.getItem(LOCAL_KEY_Location) : keyLocationOption}
            required
          >
           
            {Object.entries(KEY_LOCATION_OPTIONS).map(([optionName, text]) => (
              <option key={optionName} value={optionName}>
                {text}
              </option>
            ))}
          </Select>
          <div style={{ height: '50' }} />
        </div>
      </Modal>
      <Modal
        className="vehicle-modal"
        open={openVehicleModal}
        options={{ dismissible: false }}
      >
        <div>
          <p>First, please provide your vehicle information.</p>
        </div>
      </Modal>
      <VehicleSelectionModal
        isVehicleOpen={openVehicleSelectionModal}
        vehicleData={vehicleData}
        onClose={() => setOpenVehicleSelectionModal(false)}
        completeVehicleSearch={handleVehicleModulClose}
      />
      <PopupModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onEdit={handleEditClick}
        vehicleName={vehicle}
        onContinueClick={handleContinueClick}
        showDescription={checkServiceOtherSelected()}
      />
      <PopUpShopNow
        isOpen={modalOpenSecond}
        onClose={handleNoThanksContinueClick}
        onEdit={handleEditClickSecond}
        onBack={handleBackClickSecond}
        vehicleName={vehicle}
        sendTireQuntityValue={handleTireQuntityValue}
        simple_shop_url={z3pConfiguration.my_simple_shop_url}
        z3pClientName={z3pConfiguration.z3p_client_name}
        onCancel={handleOnCancelClick}
        cartServices={cartServices}
      />
    </>
  );
};
function mapStateToProps(state) {
  return {
    account: state.ui.account,
    vehicles: state.ui.vehicles,
    vehicle: state.ui.pricing,
    cart: state.ui.cart,
    clientLocations: state.ui.clientLocations,
    z3pConfiguration: state.ui.z3pConfiguration,
    homeAddress: state.ui.homeAddress,
    keyLocation: state.ui.keyLocation,
  };
}
export default connect(mapStateToProps, null)(AddressModal);
